import { ResetPasswordPage } from "@cavort/auth";
import { createFileRoute, useNavigate } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/forgot-password")({
	component: ForgotPasswordRoute,
});

function ForgotPasswordRoute() {
	const navigate = useNavigate();
	return <ResetPasswordPage onLoginClick={() => navigate({ to: "/login" })} />;
}
